import React from 'react';
import './Problem.css';

const Problem = () => {
  const problems = [
    '営業対応に追われて、経営の意思決定に時間が取れない',
    '採用したいが、面接対応や育成の時間が確保できない',
    '現場のエスカレーションや顧客対応で毎日が埋まってしまう',
    '売上は伸ばしたいが、営業に人手を割けない',
    '組織を大きくしたいが、採用・育成・マネジメントが回らない'
  ];

  return (
    <section id="problem" className="problem">
      <div className="container">
        <div className="problem__header animate-on-scroll">
          <h2 className="problem__title">
            こんなお悩み<br />
            ありませんか?
          </h2>
          <p className="problem__subtitle">
            中小IT企業の経営者が抱える共通課題
          </p>
        </div>

        <div className="problem__content">
          <div className="problem__list animate-on-scroll" style={{ animationDelay: '0.1s' }}>
            {problems.map((problem, index) => (
              <div 
                key={index} 
                className="problem__item animate-on-scroll"
                style={{ animationDelay: `${0.1 + index * 0.1}s` }}
              >
                <div className="problem__checkbox">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <p className="problem__text">{problem}</p>
              </div>
            ))}
          </div>

          <div className="problem__visual animate-on-scroll" style={{ animationDelay: '0.2s' }}>
            <div className="problem__circle problem__circle--outer">
              <div className="problem__circle problem__circle--middle">
                <div className="problem__circle problem__circle--inner">
                  <div className="problem__icon">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12 8V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12 16H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <p className="problem__visual-text">
              経営者が<br />
              <strong>プレイヤー</strong>になっている
            </p>
          </div>
        </div>

        <div className="problem__conclusion animate-on-scroll" style={{ animationDelay: '0.3s' }}>
          <p className="problem__conclusion-text">
            1つでも当てはまる方は、<br className="mobile-break" />
            <strong>今すぐ変革が必要</strong>です
          </p>
        </div>
      </div>
    </section>
  );
};

export default Problem;
